import { defaultFilterRanges } from '../dictionaries/dictionariesInitialState';
import { SettingsService } from 'services/settings';
import { TFiltersModel } from './filtersModel';

/**/
export const FACILITIES_FILTER_BLANK_STATE: Partial<TFiltersModel> = {
  companyValue: [],
  facilityValue: [],
  specieValue: [],
  isFarmFilterSet: false
};

/**/
export const VESSELS_FILTER_BLANK_STATE: Partial<TFiltersModel> = {
  buildYearValue: defaultFilterRanges.yearRange,
  countryValue: [],
  engineModelValue: [],
  enginePowerValue: defaultFilterRanges.powerRange,
  fleetValue: [],
  lengthValue: defaultFilterRanges.lengthRange,
  tonnageValue: defaultFilterRanges.tonnageRange,
  vesselTypeValue: [],
  isVesselFilterSet: false
};

/**/

/**/
export const filtersBlankState = {
  ...FACILITIES_FILTER_BLANK_STATE,
  ...VESSELS_FILTER_BLANK_STATE
} as TFiltersModel;

/**/
const settings: TFiltersModel =
  SettingsService.readSettings()[SettingsService.MAIN_FILTER];

export const filtersInitialState: TFiltersModel = {
  ...filtersBlankState,
  ...settings
};
